export default "__VITE_ASSET__2$qFk8Ex__"